import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/google-applications";

import MerchantCenter from "./merchant-center";

function GoogleApplications({ admin, produtos, listProducts, saveProducts, fetchGoogleStatus, removeGoogleProducts }) {
	const [listLoading, setListLoading] = useState(false);

	async function loadProducts() {
		if (!admin?.loja) return;
		setListLoading(true);
		try {
			await listProducts("decrescente", 0, 500, admin.loja);
		} finally {
			setListLoading(false);
		}
	}

	useEffect(() => {
		if (admin && !produtos) loadProducts();
	}, [admin]);

	function refreshList() {
		return loadProducts();
	}

	return (
		<div className="GoogleApplications container-centered">
			<div className="wrapper">
				<h2>
					<i className="fab fa-google" /> Applicações Google
				</h2>

				<div className="menu">
					<button type="button" className="active">
						<i className="fas fa-tag" /> Google Merchant Center
					</button>
				</div>

				<MerchantCenter
					admin={admin}
					products={produtos}
					saveProducts={saveProducts}
					fetchGoogleStatus={fetchGoogleStatus}
					removeGoogleProducts={removeGoogleProducts}
					refreshList={refreshList}
					listLoading={listLoading}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	admin: state.auth.usuario,
	produtos: state.produto.produtos,
});

export default connect(mapStateToProps, actions)(GoogleApplications);
